//require('dotenv').config();

const infuraProjectId = "40ed26b34f3c4a34b94ad9c1b8673c61"

module.exports = {
    infuraProjectId: infuraProjectId,
    tokenName: "Adora",
    tokenSymbol: "ARA",
    tokenDecimals: 18,
    tokenImage:
        "https://res.cloudinary.com/jamestan/image/upload/v1624088702/adora-256px_razuwc.png",
    tokenAddress: "0x9Ac5C63dDcb93612E316ab31dFc8192bC8961988",
    network: {
        default: 'mainnet',
        map: {
            1: 'mainnet',
            3: 'ropsten',
            4: 'rinkeby',
            42: 'kovan',
            5: 'goerli',
            56: 'bsc_mainnet',
            97: 'bsc_testnet',
        },
        list: {
            mainnet: {
                tokenType: 'ERC20',
                web3Provider: `https://mainnet.infura.io/v3/${infuraProjectId}`,
                explorerLink: 'https://etherscan.io',
                explorerName: 'Etherscan',
                id: 1,
                name: 'Main Ethereum Network',
            },
            ropsten: {
                tokenType: 'ERC20',
                web3Provider: `https://ropsten.infura.io/v3/${infuraProjectId}`,
                explorerLink: 'https://ropsten.etherscan.io',
                explorerName: 'Etherscan',
                id: 3,
                name: 'Ropsten Test Network',
            },
            rinkeby: {
                tokenType: 'ERC20',
                web3Provider: `https://rinkeby.infura.io/v3/${infuraProjectId}`,
                explorerLink: 'https://rinkeby.etherscan.io',
                explorerName: 'Etherscan',
                id: 4,
                name: 'Rinkeby Test Network',
            },
            kovan: {
                tokenType: 'ERC20',
                web3Provider: `https://kovan.infura.io/v3/${infuraProjectId}`,
                explorerLink: 'https://kovan.etherscan.io',
                explorerName: 'Etherscan',
                id: 42,
                name: 'Kovan Test Network',
            },
            goerli: {
                tokenType: 'ERC20',
                web3Provider: `https://goerli.infura.io/v3/${infuraProjectId}`,
                explorerLink: 'https://goerli.etherscan.io',
                explorerName: 'Etherscan',
                id: 5,
                name: 'Goerli Test Network',
            },
            bsc_mainnet: {
                tokenType: 'BEP20',
                web3Provider: 'https://bsc-dataseed.binance.org/',
                explorerLink: 'https://bscscan.com',
                explorerName: 'BscScan',
                id: 56,
                name: 'Binance Smart Chain',
            },
            bsc_testnet: {
                tokenType: 'BEP20',
                web3Provider: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
                explorerLink: 'https://testnet.bscscan.com',
                explorerName: 'BscScan',
                id: 97,
                name: 'Binance Smart Chain - Testnet',
            },
        },
    },
}